import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=99a8f02a"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99a8f02a')) {
      api.createRecord('99a8f02a', component.options)
    } else {
      api.reload('99a8f02a', component.options)
    }
    module.hot.accept("./Pagination.vue?vue&type=template&id=99a8f02a", function () {
      api.rerender('99a8f02a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/global/Pagination.vue"
export default component.exports